"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultisigTransferStatistics = exports.DevestingStatistics = exports.ProposalStatistic = exports.VestingTypeStatistic = exports.VestingStatistic = void 0;
var web3_js_1 = require("@solana/web3.js");
var bignumber_js_1 = __importDefault(require("bignumber.js"));
var VestingStatistic = /** @class */ (function () {
    function VestingStatistic(isActive, allTokens, unlockedTokens, availableToWithdrawTokens, withdrawn_tokens, token_account, vesting_type_account) {
        this.isActive = isActive;
        this.allTokens = allTokens;
        this.unlockedTokens = unlockedTokens;
        this.availableToWithdrawTokens = availableToWithdrawTokens;
        this.withdrawn_tokens = withdrawn_tokens;
        this.token_account = token_account;
        this.vesting_type_account = vesting_type_account;
    }
    VestingStatistic.prototype.toString = function () {
        var allTokens = new bignumber_js_1.default(this.allTokens.toString()).div(web3_js_1.LAMPORTS_PER_SOL);
        var unlockedTokens = new bignumber_js_1.default(this.unlockedTokens.toString()).div(web3_js_1.LAMPORTS_PER_SOL);
        var availableToWithdrawTokens = new bignumber_js_1.default(this.availableToWithdrawTokens.toString()).div(web3_js_1.LAMPORTS_PER_SOL);
        var withdrawn_tokens = new bignumber_js_1.default(this.withdrawn_tokens.toString()).div(web3_js_1.LAMPORTS_PER_SOL);
        return ("Active: ".concat(this.isActive ? "true" : "false", "\n") +
            "All tokens: ".concat(allTokens, "\n") +
            "Unlocked tokens: ".concat(unlockedTokens, "\n") +
            "Available to withdraw: ".concat(availableToWithdrawTokens, "\n") +
            "Withdrawn tokens: ".concat(withdrawn_tokens, "\n") +
            "Receiver associated account: ".concat(this.token_account.toString(), "\n") +
            "Vesting type account: ".concat(this.vesting_type_account.toString()));
    };
    return VestingStatistic;
}());
exports.VestingStatistic = VestingStatistic;
var VestingTypeStatistic = /** @class */ (function () {
    function VestingTypeStatistic(vesting_schedule, locked_tokens_amount, administrator, token_pool, tokensInTokenPool) {
        this.vesting_schedule = vesting_schedule;
        this.locked_tokens_amount = locked_tokens_amount;
        this.administrator = administrator;
        this.token_pool = token_pool;
        this.tokensInTokenPool = tokensInTokenPool;
    }
    VestingTypeStatistic.prototype.toString = function () {
        var locked_tokens_amount = new bignumber_js_1.default(this.locked_tokens_amount.toString()).div(web3_js_1.LAMPORTS_PER_SOL);
        var tokensInTokenPool = new bignumber_js_1.default(this.tokensInTokenPool.toString()).div(web3_js_1.LAMPORTS_PER_SOL);
        var unlockPeriod = this.vesting_schedule.unlock_period;
        var unlockPeriodTotalMinutes = unlockPeriod.divn(60);
        var unlockPeriodTotalHours = unlockPeriodTotalMinutes.divn(60);
        return ("Locked tokens: ".concat(locked_tokens_amount, "\n") +
            "Administrator: ".concat(this.administrator.toString(), "\n") +
            "Token pool: ".concat(this.token_pool.toString(), "\n") +
            "Tokens in token pool: ".concat(tokensInTokenPool, "\n") +
            "Start time: ".concat(new Date(this.vesting_schedule.start_time.muln(1000).toNumber()), "\n") +
            "End time: ".concat(new Date(this.vesting_schedule.end_time.muln(1000).toNumber()), "\n") +
            "Cliff: ".concat(new Date(this.vesting_schedule.cliff.muln(1000).toNumber()), "\n") +
            "Unlock period: ".concat(unlockPeriodTotalHours.divn(24), " days, ").concat(unlockPeriodTotalHours.modn(24), " hours, ") +
            "".concat(unlockPeriodTotalMinutes.modn(60), " minutes and ").concat(unlockPeriod.modn(60), " seconds\n") +
            "Initial unlock: ".concat(this.vesting_schedule.initial_unlock.toString()));
    };
    return VestingTypeStatistic;
}());
exports.VestingTypeStatistic = VestingTypeStatistic;
var ProposalStatistic = /** @class */ (function () {
    function ProposalStatistic(proposalExists, multisigTokens, signed, nonSigned, requiredSignatures) {
        this.proposalExists = proposalExists;
        this.multisigTokens = multisigTokens;
        this.signed = signed;
        this.nonSigned = nonSigned;
        this.requiredSignatures = requiredSignatures;
    }
    return ProposalStatistic;
}());
exports.ProposalStatistic = ProposalStatistic;
var DevestingStatistics = /** @class */ (function (_super) {
    __extends(DevestingStatistics, _super);
    function DevestingStatistics() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return DevestingStatistics;
}(ProposalStatistic));
exports.DevestingStatistics = DevestingStatistics;
var MultisigTransferStatistics = /** @class */ (function (_super) {
    __extends(MultisigTransferStatistics, _super);
    function MultisigTransferStatistics(proposalExists, multisigTokens, signed, nonSigned, requiredSignatures, transfers) {
        var _this = _super.call(this, proposalExists, multisigTokens, signed, nonSigned, requiredSignatures) || this;
        _this.proposalExists = proposalExists;
        _this.multisigTokens = multisigTokens;
        _this.signed = signed;
        _this.nonSigned = nonSigned;
        _this.requiredSignatures = requiredSignatures;
        _this.transfers = transfers;
        return _this;
    }
    return MultisigTransferStatistics;
}(ProposalStatistic));
exports.MultisigTransferStatistics = MultisigTransferStatistics;
//# sourceMappingURL=query.js.map